// src/components/page-content-v4/PageListPage.tsx

import React from 'react';
import { PageListProvider, usePageListContext } from './contexts/PageListContext';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import PageFormMain from '@/components/page-content-v4/PageFormMain';
import PageList from './modules/PageList';

const PageListContent: React.FC = () => {
  const { template, pages, isLoading, error, pagination, setPagination, totalItems, refreshPages } = usePageListContext();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <div>Error loading pages.</div>;

  if (!template) return <div>Template not found.</div>;

  if (template.isSinglePage) {
    return <PageFormMain />;
  }

  return (
    <PageList
      pages={pages}
      pagination={pagination}
      setPagination={setPagination}
      totalItems={totalItems}
      refreshPages={refreshPages}
    />
  );
};

const PageListMain: React.FC = () => (
  <PageListProvider>
    <PageListContent />
  </PageListProvider>
);

export default PageListMain;
